exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".body-item-left[data-v-66840334]{overflow:hidden;position:relative;margin-top:15px;width:48%;float:left}.body-item-right[data-v-66840334]{overflow:hidden;position:relative;margin-top:15px;width:48%;float:right}.body-title[data-v-66840334]{background:#e87b92;padding:6px;position:absolute;color:#fff;margin-left:15px}.body-content[data-v-66840334]{line-height:30px;font-size:15px;min-height:70px;border:1px solid #ddd;border-radius:5px;margin-top:15px;padding-top:27px;padding-left:15px;padding-bottom:19px}.product-buyer-name[data-v-66840334]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-66840334","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/pdQualityControlManage/pdSummary/index.vue
// module id = QV/o
// module chunks = 0